import React, { useMemo } from 'react';

import { Title } from '@components/Title';

import { useThemeGetter } from '@hooks';

import { mainInfo } from '@consts';

import { StackItem } from './StackItem';

import { getStackList } from './StackBox.utils';

import { useGetActiveStackItem } from './StackBlock.hooks';

import { StackBlockContainer, StackListContainer } from './StackBlock.styled';

export const StackBlock = () => {
  const {
    theme: { Title: TitleColor },
  } = useThemeGetter();

  const checkStackNameOnActive = useGetActiveStackItem();

  const stack = useMemo(() => getStackList(mainInfo.EXPERIENCE_INFO), []);

  return (
    <StackBlockContainer>
      <Title text="Stack" size={3} color={TitleColor} />
      <StackListContainer>
        {stack.map((one) => (
          <StackItem
            key={one.name}
            length={one.length}
            text={one.name}
            active={checkStackNameOnActive(one.name)}
          />
        ))}
      </StackListContainer>
    </StackBlockContainer>
  );
};
